import { api } from "./api";
import type { AdminMeResponse } from "@/types/adminAuth";

// Source: backend/app/api/v1/admin_auth.py — the SEPARATE admin realm. Uses the
// distinct `asoloop_admin_session` cookie (sent via withCredentials), never the
// customer session.

export async function fetchAdminMe(): Promise<AdminMeResponse> {
  const { data } = await api.get<AdminMeResponse>("/api/v1/admin-auth/me");
  return data;
}

export async function adminLogin(
  email: string,
  password: string,
): Promise<AdminMeResponse> {
  const { data } = await api.post<AdminMeResponse>("/api/v1/admin-auth/login", {
    email,
    password,
  });
  return data;
}

export async function adminLogout(): Promise<void> {
  await api.post("/api/v1/admin-auth/logout");
}

export async function adminSetPassword(
  token: string,
  newPassword: string,
): Promise<AdminMeResponse> {
  const { data } = await api.post<AdminMeResponse>(
    "/api/v1/admin-auth/set-password",
    { token, new_password: newPassword },
  );
  return data;
}

export async function adminForgotPassword(email: string): Promise<void> {
  await api.post("/api/v1/admin-auth/forgot-password", { email });
}
